import { render, staticRenderFns } from "./design_sidebar.vue.js?vue&type=template&id=3db78858!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_sidebar.vue?vue&type=template&id=3db78858"
import script from "./design_sidebar.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_sidebar.vue?vue&type=script&lang=js"
export * from "./design_sidebar.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./design_sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports